var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"product-row-list"},[_c('v-col',{staticClass:"pl-5"},[_vm._v(" "+_vm._s(_vm.product.name2?_vm.product.name2:_vm.product.name)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }